import { z } from "zod";

const RoleSchema = z.object({
    id: z.number(),
    name: z.string(),
    display_name: z.string(),
    guard_name: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
})

export const CreateRoleResponse = z.object({
    code: z.number(),
    success: z.boolean(),
    message: z.string(),
    data: RoleSchema
});